<template>
  <router-view v-slot="{ Component }">
    <router-link to="/home" v-if="currentRouteName !== 'home'">
      <button-close :element="currentRouteName"/>
    </router-link>

    <transition
        :enter-from-class="currentRouteName+'-from'"
        :enter-to-class="currentRouteName+'-to'"
        enter-active-class="animation"
        leave-active-class="animation"
        leave-from-class="animation-leave-from"
        leave-to-class="animation-leave-to"
    >
      <component :is="Component"/>
    </transition>
    <the-footer v-if="currentRouteName !== 'home'"></the-footer>
  </router-view>
</template>

<script>
import ButtonClose from "@/components/buttons/ButtonClose";
import TheFooter from "@/components/layout/TheFooter";


export default {
  components: {
    TheFooter,
    ButtonClose,
  },

  computed: {
    currentRouteName() {
      return this.$route.fullPath.replace('/', '');
    }
  }
}
</script>

<style>
body::-webkit-scrollbar {
  display: none;
}

section {
  width: 100%;
}

.animation {
  transition: all .6s;
}

.animation-leave-to {
  position: absolute;
  top: 0;
  opacity: 0.75;
}

.animation-leave-from {
  position: absolute;
  top: 0;
  opacity: 1;
}

.contact-from {
  position: absolute;
  left: 100%;
}

.contact-to {
  position: absolute;
  left: 0;
}

.about-from {
  position: absolute;
  top: -50%;
}

.about-to {
  position: absolute;
  top: 0;
}

.strength-from {
  position: absolute;
  top: 100%;
}

.strength-to {
  position: absolute;
  top: 0;
}

.portfolio-from {
  position: absolute;
  left: -100%;
}

.portfolio-to {
  position: absolute;
  left: 0;
}

.home-from {
  position: fixed;
  top: 0;
  opacity: 0;
  transform: scale(0.9);
}

.home-to {
  position: fixed;
  top: 0;
  opacity: 1;
  transform: scale(1);
}
</style>